<!-- 由 Dioa 创建于 2023-05-05 星期五 -->
<template>
  <div :style="styles">
    <video
      :src="propValue"
      controls
      loop
      crossorigin="Anonymous"
      :poster="
        propValue + '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'
      "
    >
    </video>
  </div>
</template>

<script>
export default {
  name: 'index',

  components: {},

  props: {
    propValue: {
      required: false,
      type: String,
      default: () => {
        return ''
      }
    },
    styles: {
      required: false,
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
video {
  width: 100%;
  height: 100%;
}
</style>
